import Vue from 'vue'
import App from './App.vue'
import VueFullpage from 'vue-fullpage.js'
import VueI18n from 'vue-i18n'
import './utils/rem.js'

Vue.use(VueI18n)
import EasySlider from 'vue-easy-slider'

Vue.use(EasySlider)
// 挂载到vue全局上
Vue.use(VueFullpage)
Vue.config.productionTip = false
console.log(localStorage.getItem('user_lang'), '用户')
const i18n = new VueI18n({
  locale: localStorage.getItem('user_lang') == null ? "en" : localStorage.getItem('user_lang'),    // 语言标识
  messages: {
    'cn': require('./lang/cn'),   // 中文语言包
    'en': require('./lang/en')    // 英文语言包
  },
})
const app = new Vue({
    i18n,
	// mounted () {
	//     // You'll need this for renderAfterDocumentEvent.
	//     document.dispatchEvent(new Event('render-event'))
	// },
    ...App
}).$mount('#app')
